import { generatePath, useMatch } from 'react-router-dom'

import { Icon } from '../Icons/Icon'
import { SidenavButton, SidenavTooltip } from './Sidenav.parts'

export interface HomeButtonProps {
  renderDelay: boolean
}

export const routes = {
  /**
   * Home path
   */
  root: '/',
  /**
   * Dynamic pages
   */
  screen: '/:screen',
}

//todo: delete this. was only used here.
export const generateScreenPath = (params: { screen: string }) =>
  generatePath(routes.screen, params)
const DASHBOARD_PATH = generateScreenPath({ screen: 'dashboard' })

export const HomeButton = ({ renderDelay }: HomeButtonProps) => {
  const isDashboardPage = !!useMatch(DASHBOARD_PATH)

  return (
    <SidenavTooltip
      label="Home"
      isDisabled={renderDelay}
      marginLeft={renderDelay ? '18px' : ''}
    >
      <SidenavButton
        to={DASHBOARD_PATH}
        justifyContent="center"
        _hover={{
          backgroundColor: 'presets.turquoise.80',
          borderColor: 'presets.turquoise.80',
          color: 'presets.neutral.0',
        }}
        _active={{
          backgroundColor: 'presets.turquoise.40',
          borderColor: 'presets.turquoise.40',
          color: 'presets.neutral.0',
        }}
        isActive={isDashboardPage}
        backgroundColor="transparent"
        borderColor="presets.turquoise.60"
        color="presets.turquoise.30"
        leftIcon={renderDelay ? <Icon icon="HomeIcon" /> : undefined}
      >
        {renderDelay ? 'Home' : <Icon icon="HomeIcon" />}
      </SidenavButton>
    </SidenavTooltip>
  )
}
